import {
  FEATURE_FLAGS,
  getFeatureFlag,
  type FeatureFlagName,
} from 'app/config/environment/feature-flag';
import {
  isAskMaxPartnerEnabled,
  isDailyHubV2PartnerEnabled,
  isDocumentChecklistPartnerEnabled,
} from 'app/config/environment/partnerConfig';

export { FEATURE_FLAGS } from 'app/config/environment/feature-flag';

// Flags that also require the partner to opt in, so one environment variable cannot switch a
// brokerage over on its own. Declared per flag rather than as a hook per flag: the call sites stay
// ordinary useFeatureFlag reads and there is one place to look for which flags carry a second lock.
//
// It lives here rather than in the env parser so partnerConfig's import graph stays out of the
// non-React getFeatureFlag, which services and utils call.
const PARTNER_GATED: Partial<Record<FeatureFlagName, () => boolean>> = {
  [FEATURE_FLAGS.DAILY_HUB_V2]: isDailyHubV2PartnerEnabled,
  [FEATURE_FLAGS.DOCUMENT_CHECKLIST]: isDocumentChecklistPartnerEnabled,
  [FEATURE_FLAGS.ASK_MAX]: isAskMaxPartnerEnabled,
};

export function useFeatureFlag(name: FeatureFlagName): boolean {
  if (!getFeatureFlag(name)) return false;
  return PARTNER_GATED[name]?.() ?? true;
}
